const faqItems = [
  {
    q: '58影院真的完全免费吗？需要注册会员吗？',
    a: '是的，58影院所有电视剧全集完全免费在线观看，无需注册会员，无需任何付费。打开网页即可直接观看，真正零门槛追剧体验。',
  },
  {
    q: '电视剧画质怎么样？会不会经常缓冲卡顿？',
    a: '58影院提供高清流畅画质，采用多线路智能切换技术，根据您的网络带宽自动选择最优播放线路，确保追剧过程流畅不卡顿。建议在网络稳定的环境下观看以获得最佳体验。',
  },
  {
    q: '最新电视剧多久能更新上线？',
    a: '58影院与全网同步更新，热播电视剧通常在播出后第一时间上线。我们的内容团队每日更新剧集资源，确保您追剧永远快人一步。',
  },
  {
    q: '手机端可以看吗？需要下载APP吗？',
    a: '完全不需要下载APP！58影院完美适配手机、平板和电脑浏览器，无论iOS还是Android设备，打开浏览器访问即可畅享高清追剧，随时随地想看就看。',
  },
  {
    q: '支持哪些类型的电视剧？',
    a: '58影院覆盖国产剧、韩剧、美剧、日剧、泰剧等热门分类，包括古装传奇、都市情感、悬疑刑侦、武侠江湖、青春偶像、家庭伦理、历史正剧、科幻奇幻、喜剧搞笑等全类型剧集，总有一部适合你。',
  },
  {
    q: '观看电视剧有广告吗？会不会弹窗？',
    a: '58影院致力于提供清爽的追剧体验，尽量控制广告干扰。我们建议使用浏览器自带的广告拦截功能获得更纯净的观看体验。本站始终以用户体验为优先。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于58影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-100 transition-all duration-300 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 font-heading mb-2 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed pl-9">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}